import { combineReducers } from 'redux';

import policyReducer from './policy';

export default combineReducers({
  policy: policyReducer
});
